export const GET_BD_PAYMENT_METHOD = "GET_BD_PAYMENT_METHOD";
export const CREATE_BD_PAYMENT_METHOD = "CREATE_BD_PAYMENT_METHOD";
export const UPDATE_BD_PAYMENT_METHOD = "UPDATE_BD_PAYMENT_METHOD";
export const DELETE_BD_PAYMENT_METHOD = "DELETE_BD_PAYMENT_METHOD";
export const TOGGLE_BD_PAYMENT_METHOD = "TOGGLE_BD_PAYMENT_METHOD";

export const OPEN_BD_PAYMENT_METHOD_DIALOG = "OPEN_BD_PAYMENT_METHOD_DIALOG";
export const CLOSE_BD_PAYMENT_METHOD_DIALOG = "CLOSE_BD_PAYMENT_METHOD_DIALOG";
